<template>
    <div class="main">
        <div class="top">
            <van-nav-bar title="新建学生信息" left-arrow @click-left="onClickLeft" />
            <van-form @submit="onSubmit" class="register_box">
                <van-field v-model="realname" name="姓名" :required="true" label="姓名" placeholder="请填写学生姓名"
                    :rules="[{ required: true, message: '请填写学生姓名' }]" />


                <van-field readonly clickable name="picker1" :value="gender" :required="true" label="性别" placeholder="请选择性别"
                    @click="showPicker1 = true" />
                <van-popup v-model="showPicker1" position="bottom">
                    <van-picker show-toolbar :columns="columns1" @confirm="onConfirm1" @cancel="showPicker = false" />
                </van-popup>

                <van-field readonly clickable name="picker2" :required="true" :value="school" label="学校" placeholder="请选择学校"
                    @click="showPicker2 = true" />
                <van-popup v-model="showPicker2" position="bottom">
                    <van-picker show-toolbar :columns="schools" value-key="school" @confirm="onConfirm2" @cancel="showPicker = false" />
                </van-popup>

                <van-field readonly clickable name="picker3" :required="true" :value="join_year" label="入学年份" placeholder="请选择学生一年级入学年份"
                    @click="showPicker3 = true" />
                <van-popup v-model="showPicker3" position="bottom">
                    <van-picker show-toolbar :columns="years" @confirm="onConfirm3" @cancel="showPicker = false" />
                </van-popup>

                <van-field v-model="id_card" name="身份证" :required="true" label="身份证" placeholder="请填写学生身份证号码"
                    :rules="[{ required: true, message: '请填写正确的学生身份证号码', validator: id_card_check  }]" />
                <div class="btn_box">
                    <van-button class="btn" type="primary" round size="normal" color="linear-gradient(#0DCCFF,#4760FF)"
                        text="确认登记" native-type="submit" :loading="isLoading" loading-text="提交中" />
                </div>
            </van-form>
        </div>
    </div>
</template>

<script scoped>
import { Toast } from 'vant';
import { getSchool, saveUser, getUserInfo } from '@/api/snjx'
import { isValidIdCard18Digit } from '@/utils/common'

export default {
    data() {
        return {
            themeId: 1,
            isLoading: false,
            realname: '',
            gender: '',
            showPicker1: false,
            columns1: ['男', '女'],
            showPicker2: false,
            schools: [],
            showPicker3: false,
            years: ['2018', '2019', '2020','2021','2022'],
            school: '',
            school_id: 0,
            join_year: '',
            id_card: '',
        };
    },
    methods: {
        id_card_check(value){
            return isValidIdCard18Digit(value)
        },
        onClickLeft() {
            this.$router.back();
        },
        onConfirm1(gender) {
            this.gender = gender;
            this.showPicker1 = false;
        },
        onConfirm2(e) {
            this.school = e.school;
            this.school_id = e.id
            this.showPicker2 = false;
        },
        onConfirm3(join_year) {
            this.join_year = join_year;
            this.showPicker3 = false;
        },
        onSubmit(values) {
            if(this.isLoading) return;
            this.isLoading = true;

            let data = {
                theme_id: this.themeId,
                realname: this.realname,
                gender: this.gender,
                school: this.school,
                school_id: this.school_id,
                join_year: this.join_year,
                id_card: this.id_card,
            };

            saveUser(data).then((res) => {
                if(res.code == 1){
                    Toast({
                        type: 'success',
                        message: res.msg,
                        onClose: () => {
                            this.$router.replace({name: 'snjx_index'})
                        }
                    })
                }else{
                    this.isLoading = false
                    Toast.fail(res.msg)
                }
            })
        },
    },
    created() {
        getUserInfo({theme_id: this.themeId}).then((res) => {
            if(res.code == 1){
                if(res.data){
                    this.$router.push({name: 'snjx_index'})
                }else{
                    getSchool({type_id: 1}).then((res) => {
                        if(res.code == 1){
                            this.schools = res.data
                        }else{
                            Toast.fail(res.msg)
                        }
                    })
                }
            }else{
                Toast.fail(res.msg);
            }
        })
        
    },
    mounted() {
    },
};
</script>

<style lang="less" scoped>
* {
    margin: 0;
    padding: 0;
}

.main {
    height: 100vh;
    background-color: #F5F5F5;
}

.top {
    background:url('https://i.tmuyun.com/webpic/W0202407/W020240718/W020240718694322070720.png') no-repeat;
    background-size: 100%;
}

/deep/ .van-nav-bar {
    background: none;
    .van-hairline--bottom{
        border: 0;
    }
    .van-icon {
        color: #fff;
    }
    .van-nav-bar__title {
        color:#fff;
        font-weight: bold;
        font-size: 14px;
    }
}

.register_box {
    margin: 20px;
.van-field {
    padding: 20px;
}
}

/deep/ .van-cell__title {
    margin: 0 0 0 10px;
}

.van-button {
    margin: 55px 0 0 0;
}

.btn_box {
    display: flex;
    justify-content: space-around;
}

.btn {
    width: 350px;
    height: 36px;
    line-height: 36px;
    letter-spacing: 5px;
    font-size: 20px;
    font-style: italic;
    font-weight: bold;
}
</style>